<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 md-small-size-100 md-xsmall-size-100 text-center">
            <h1 class="title">Activities
              <br>
              <small class="text-white">Welcome to be here!</small>
            </h1>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center">STAY & PLAY</h2>
              <h3 class="md-body-3">
                Our staff is available to help plan your activities!
              </h3>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="section section-middle">
        <div class="container">
          <div class="elevation-demo">
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-80 text-left">
                <h3 class="title text-center">OrangeTree Bar & Restaurant</h3>
                <h4>OPEN</h4>
                <h5 class="text-left">
                  <br>4:00 p.m. – 10:00 p.m. Monday - Saturday
                  <br>(Bar service until 11:00 p.m. Fri & Sat)
                </h5>
                <h4>CLOSED</h4>
                <h5 class="text-left">
                  <br>Sunday
                </h5>
                <md-button
                  href="/kitchen"
                  class="md-success md-lg"
                  target="_self"
                  ><md-icon>info</md-icon>Learn More
                </md-button>
              </div>
            </md-content>
            <md-content class="md-elevation">
              <img
                :src="img1"
                alt="Restaurant"
                class="img-raised"
              />
            </md-content>
            <md-content class="md-elevation">
              <img
                :src="img2"
                alt="Theater"
                class="img-raised"
              />
            </md-content>
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-80 text-center">
                <h3 class="title">Schulman’s Movie Bowl Grille</h3>
                <h5 class="text-right">Movie theater
                  <br>Bowling<br>Amusement Arcade</h5>
              </div>
            </md-content>
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-90 text-center">
                <h3 class="title">Lake Texoma</h3>
                <h5 class="text-left">Sprawling lake for water recreation bordered by marinas, campgrounds, parks & wildlife refuges.</h5>
              </div>
            </md-content>
            <md-content class="md-elevation">
              <img
                :src="img3"
                alt="Lake Texoma"
                class="img-raised"
              />
            </md-content>
            <md-content class="md-elevation">
              <img
                :src="img4"
                alt="Allen Outlet Mall"
                class="img-raised"
              />
            </md-content>
            <md-content class="md-elevation">
              <div class="md-layout-item md-size-90 text-center">
                <h3 class="title">Allen Outlet Mall</h3>
                <h5 class="text-right">Outdoor outlet mall with dining options, featuring clothing, accessory, shoe & home stores.</h5>
              </div>
            </md-content>
          </div>
        </div>
      </div>
      <hr>
      <div class="section section-bottom">
        <div class="container">
          <div class="md-layout-item md-size-100 text-center">
            <h3 class="title">Weekend Getaway without the Drive!</h3>
            <!-- <h5>Celebrate your next special event, whether it be a wedding rehearsal, baby shower, corporate celebration, club events and more, with us. We offer customized menus at various price points to fit your group needs. For smaller events, we offer a private dining room that seats up to 14 around our farmhouse dining table. </h5> -->
            <!-- <md-button
              href="/reserveation"
              class="md-orange md-lg"
              target="_self"
              ><md-icon>today</md-icon>Check Availability
            </md-button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "@/components";
export default {
  components: {
    Modal
  },
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/activities_header.jpg")
    },
    img1: {
      type: String,
      default: require("@/assets/img/activities_bar.jpg")
    },
    img2: {
      type: String,
      default: require("@/assets/img/activities_theater.jpg")
    },
    img3: {
      type: String,
      default: require("@/assets/img/activities_lake.jpg")
    },
    img4: {
      type: String,
      default: require("@/assets/img/activities_outlet.jpg")
    }
  },
  data() {
    return {
      classicModal: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
        11: false,
        12: false
      },
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    classicModalHide(e) {
      this.classicModal[e] = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 40px;
}
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.page-header {
  b {
    font-size: 4.2rem
  }
}
.info{
  padding-top: 20px;
}
.elevation-demo {
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
}
.t_img1 {
  margin-top: 58px;
}
hr {
  margin-top: 1rem;
  // margin-bottom: 0.5rem;
  border: 0;
  width: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.md-elevation {
  height: auto;
  // margin: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  a {
    width: 100%;
    height: 100%;
    position: relative;
    // i {
    //   display: table-cell;
    //   position: absolute;
    //   top:0;
    //   right: 0;
    //   bottom: 0;
    //   left: 0;
    //   font-size: 2.0rem;
    //   font-weight: bold;
    //   vertical-align: middle;
    //   text-align: center;
    //   font-style: normal; 
    //   background: rgba(245, 124, 0, 0.5);
    //   color: #fff;
    //   opacity: 0;
    //   z-index: 9;
    //   padding: 50% 0 0 0;
    //   transition: opacity 0.4s ease 0s;
    // }
    // &:hover {
    //   i {
    //     opacity: 1;
    //   }
    // }
  }
}
.section-middle .md-elevation {
  width: 50%;
}
.section-bottom .md-elevation {
  width: 20%;
}
@media (max-width: 768px){
  .section-middle .md-elevation, .section-bottom .md-elevation {
    width: 100%;
  }
}
</style>
